import React, { useState } from 'react';
import ValidatePasswordCreation from '../common/validatePasswordCreation';

const ModalCreate = (props) => {
  const [password, setPassword] = useState('');
	const [repeatPassword, setRepeatPassword] = useState('');
  const [passwordIsValid, setPasswordIsValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordIsValid = (isValid) => {
    setPasswordIsValid(isValid);
  }

  if(!props.modal) {
    return null;
  }

  return (
    <div
      data-close="ok"
      onClick={props.handleModal}
      className={`container-modal`}
    >
      <section className="module-title modal-title">
        <h2>{props.language.account.accountUser.createUser}</h2>
        {props.statusSave == 500 &&
          props.dataSave.error.params.map((item, i) => (
            <p key={i} className="error">
              {props.language.error[`cod${item.messageCode}`]}{' '}
            </p>
          ))}
        <a>
          <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
        </a>
      </section>
      {props.statusSave != 200 && (
        <div className={`box-modal max500`}>
          <section id="modal-create" className="base-form">
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.name}
                  <strong>(*)</strong>
                </label>
              </div>
              <div>
                <input autoComplete="off" type="text" id="name" className="modal-input" />
              </div>
            </div>
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.email}
                  {'  '}
                  <strong>(*)</strong>{' '}
                </label>
              </div>
              <div>
                <input autoComplete="off" type="text" id="mail" className="modal-input" />
              </div>
            </div>
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.password}
                  <strong>(*)</strong>{' '}
                </label>
              </div>
              <div className="input-icon-container">
                <input
                  autoComplete="off"
                  type={showPassword ? 'text' : 'password'}
                  id="pass"
                  className="modal-input"
                  onChange={e => setPassword(e.target.value)}
                />
                <i
                  className={`icon fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} `}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.repeatPassword} <strong>(*)</strong>{' '}
                </label>
              </div>
              <div className="input-icon-container">
                <input
                  autoComplete="off"
                  type={showPassword ? 'text' : 'password'}
                  id="repeat_pass"
                  className="modal-input"
                  onChange={e => setRepeatPassword(e.target.value)}
                />
                <i
                  className={`icon fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} `}
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
            <div className="box-form islabel">
              <ValidatePasswordCreation
                password={password}
                repeatPassword={repeatPassword}
                onPasswordIsValid={handlePasswordIsValid}
                language={props.language}
              />
            </div>
            {props.root == 'true' && (
              <div className="box-form islabel top">
                <label className="container-checkbox">
                  {props.language.account.accountUser.isAdmin}
                  <input id="roote" onClick={props.handleAdmin} type="checkbox" />
                  <span className="checkmark" />
                </label>
              </div>
            )}
            <div className="box-form islabel">
              <div>
                <label className="modal-label">
                  {props.language.account.accountUser.rol}
                  <strong>(*)</strong> <p>{props.language.account.accountUser.labelSelection}</p>
                </label>
              </div>
              <div>
                <ul className="multiple-select big" id="role">
                  {props.optionsToCreateUser.roles.map((item, i) => (
                    <li
                      onClick={item.editable ? props.handleSelectCheck : null}
                      data-rol={`rol-${i}`}
                      data-parent={`rol-${i}`}
                      data-roleparent={"role"}
                      id={`rol-${i}`}
                      key={`rol-${i}`}
                      data-value={item.valueKey}
                      className={item.editable ? "enabled-item" : "disabled-item"}
                      ref={(el) => props.permissionsRef[item.valueKey] = el}
                    >
                      {props.language.account.accountUser[item.valueKey.toLowerCase()]}{' '}
                      <span className="help">
                        <i className="fas fa-question-circle" />
                        <div className="min"> {props.language.account.roles[item.valueKey]}</div>
                      </span>{' '}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            {props.filter.length > 0 && (
              <div className="module-title left">
                <h2>
                  {props.language.account.others.categories} <strong>(*)</strong> <p>{props.language.account.others.categoriesHelp}</p>
                </h2>
                <p className="tagsSelectorDescription">{props.multipleTagsAllow ? props.language.account.others.selectMultipleItemsCategories :
                      props.language.account.others.selectOneItemCategories}</p>
              </div>
            )}
            {props.optionsToCreateUser.categories.map((item, i) => (
              <div className="box-form islabel" key={`tags-${i}`}>
                <div>
                  <label className="modal-label">
                    {props.language.filter[item.category.valueKey.toLowerCase()]}
                  </label>
                </div>
                <div>
                  <ul className={"multiple-select " + (props.multipleTagsAllow ? "big" : "radio")} id={`list-${i}`} data-list={`list-${i}`}>
                    {item.tags.map((tag, e) => {
                      return (
                        <li
                          onClick={tag.editable? props.handleSelect : null}
                          data-parent={`list-${i}`}
                          id={`list-${i}-${e}`}
                          key={`list-${i}-${e}`}
                          data-category={item.category.valueKey.toUpperCase()}
                          data-value={tag.valueKey}
                          className={tag.editable ? "" : "disabled-item"}
                        >
                          {tag.valueKey == "*" ? props.language.all : tag.valueKey}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            ))}
          </section>
        </div>
      )}
      {props.statusSave != 200 && (
        <div className={'box-form islabel top center modal-button-box '}>
          <div>
            {props.loadingSave ? (
              <div className="spiner">
                <i className="fas fa-spinner fa-spin" /> {props.language.account.others.loading}
              </div>
            ) : (
              <input
                className={passwordIsValid ? 'active' : 'disabled'}
                onClick={props.handleSubmit}
                type="button"
                value={props.language.account.accountUser.createUser}
                disabled={!passwordIsValid}
              />
            )}
          </div>
        </div>
      )}
      {props.statusSave == 200 && (
        <div className={`box-modal max500`}>
          <section className={'feed-back green'}>
            <div>
              <i className="fas fa-check-circle" />
            </div>
            <div>
              <p>{props.language.account.accountUser.userSuccess}</p>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}

export default ModalCreate;



// WEBPACK FOOTER //
// ./source/client/components/account_user/modalCreate.jsx